// ==================== AFFILIATE LINKS CONFIG ====================

export const affiliates = {
  // ── Kiwi.com flights ────────────────────────────────────────
  kiwi: {
    name: 'Kiwi.com',
    tagline: 'Find the cheapest flights with flexible dates.',
    home: 'https://kiwi.tpx.gr/5lFIeRk3',
    search: () => 'https://kiwi.tpx.gr/5lFIeRk3',
    cta: 'Search Flights on Kiwi',
    note: 'Mix-and-match airlines for cheaper fares',
  },

  // ── Trip.com hotels ─────────────────────────────────────────
  trip: {
    name: 'Trip.com',
    tagline: 'Hotels, flights, and travel packages worldwide.',
    home: 'https://www.trip.com/t/NnXFRXrHiT2',
    hotels: 'https://www.trip.com/t/hbb4IghIiT2',
    search: () => 'https://www.trip.com/t/hbb4IghIiT2',
    cta: 'Find Hotels on Trip.com',
    note: 'Bundle flights + hotel for extra savings',
  },

  // ── Airalo eSIM ─────────────────────────────────────────────
  airalo: {
    name: 'Airalo',
    tagline: 'Best eSIM marketplace. Works in 200+ countries.',
    home: 'https://airalo.tpx.gr/OfM2Xs4n',
    country: () => 'https://airalo.tpx.gr/OfM2Xs4n',
    cta: 'Get Your eSIM on Airalo',
    note: 'First-time users get 10% off with our link',
  },

  // ── Saily eSIM ──────────────────────────────────────────────
  saily: {
    name: 'Saily',
    tagline: 'eSIM by Nord Security. No app download required — activate with a QR code.',
    home: 'https://saily.tpx.gr/yOJg905y',
    cta: 'Get Your eSIM on Saily',
    note: 'Buy online and activate via QR code. Made by the people behind NordVPN.',
  },

  // ── Yesim eSIM ──────────────────────────────────────────────
  yesim: {
    name: 'Yesim',
    tagline: 'Global eSIM with built-in VPN.',
    home: 'https://yesim.tpx.gr/nyV5W6J0',
    cta: 'Check Yesim Plans',
    note: 'Includes built-in VPN for secure browsing',
  },

  // ── Expedia (package / US fallback) ─────────────────────────
  expedia: {
    name: 'Expedia',
    tagline: 'Flights, hotels, and vacation packages.',
    hotels: 'https://www.tkqlhce.com/click-101689576-12639039',
    packages: 'https://www.dpbolvw.net/click-101689576-13364951',
    us: 'https://www.tkqlhce.com/click-101689576-12639039',
    home: 'https://www.tkqlhce.com/click-101689576-12639039',
    search: () => 'https://www.tkqlhce.com/click-101689576-12639039',
    cta: 'Find Hotels on Expedia',
    note: 'Compare hotels and bundle with flights for extra savings',
  },
};

export default affiliates;
